import { defineComponent as _defineComponent } from 'vue'
import { ref, withDefaults } from 'vue';
import { SideSheet } from '@/modules/common/components/SideSheet';
import {
  ButtonIconContextual,
  BaseText,
  Heading,
  ContentDisplay,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { IMarginAllocationV2 } from '@/modules/trade/services/margin-allocation';
import { Money } from '@/modules/common/components/MoneyV2';
import { useRouter } from 'vue-router/composables';

interface Props {
  isOpen: boolean;
  marginAllocation?: IMarginAllocationV2;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MarginAllocationDrawer',
  props: {
    isOpen: { type: Boolean, default: false },
    marginAllocation: { default: () => ({} as IMarginAllocationV2) }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { isOpen: boolean, marginAllocation: IMarginAllocationV2 };

const router = useRouter();

const sheet = ref<HTMLElement | null>(null);





const handleSheetClose = () => {
  emit('close');
};

const handleEditLimit = () => {
  router.push({
    name: 'marginAllocation'
  });
};

return { __sfc: true,router, sheet, props, emit, handleSheetClose, handleEditLimit, SideSheet, ButtonIconContextual, BaseText, Heading, ContentDisplay, ListDisplay, ButtonPrimary, Money }
}

})